import { PRIVACY_NOTICE_VERSION } from "@tabbio/utils/analytics/consent";

/** One ordered receipt writer shared by each browser surface's consent store. */
export function createVisitorConsentSync(
  apiBase: () => string | Promise<string>,
  send: typeof fetch = (...args) => fetch(...args),
) {
  let pending = Promise.resolve();
  return (choices: { analytics: boolean; marketing: boolean }) => {
    const body = JSON.stringify({
      ...choices,
      noticeVersion: PRIVACY_NOTICE_VERSION,
    });
    pending = pending.then(async () => {
      // The HttpOnly receipt is shared across origins/tabs. Another document
      // can replace it, so even an unchanged local choice must be sent again.
      try {
        await send(
          new URL("/api/privacy/visitor-consent", await apiBase()),
          {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body,
            keepalive: true,
            signal: AbortSignal.timeout(5000),
          },
        );
      } catch {
        /* Retried on the next notification. A receipt never authorizes local capture. */
      }
    });
    return pending;
  };
}
